// extracted by mini-css-extract-plugin
module.exports = {"boxContain":"styles_boxContain__1AOHz","colorContainer":"styles_colorContainer__2e0dG"};